export const ACTIONS = {
  ADD_TASK: "ADD_TASK",
  DELETE_TASK: "DELETE_TASK",
  UPDATE_START_TIME: "UPDATE_START_TIME",
  UPDATE_STOP_TIME: "UPDATE_STOP_TIME",
  INCREMENT_TIMER: "INCREMENT_TIMER",
  UPDATE_TIMER: "UPDATE_TIMER",
  CLOSE_TIME: "CLOSE_TIME",
};
